import { createAction, props } from '@ngrx/store';
import {
  CandidateProcedure,
  CandidateProcedureDecision,
  CandidateVerification,
  UpdateCandidateVerificationDecisionOpts,
  CandidateVerificationHistory,
  NewCandidateVerificationOpts,
  PaginatedResponse,
  SearchCandidateVerificationsOpts,
  ServiceTypeOptional,
  SmsSendResult,
  UpdateCandidateVerificationDetailsOpts,
  User,
  UserProcess,
} from '@interfaces';
import { ManagerOfCompany, SearchProcessesOfManagedEmployees } from 'src/app/_interfaces/manager';

export const getMyManagedCompanies = createAction('[Manager] Get My Managed Companies');
export const getMyManagedCompaniesSuccess = createAction(
  '[Company Manager] Get My Managed Companies SUCCESS',
  props<{ managedCompanies: ManagerOfCompany[] }>()
);
export const getMyManagedCompaniesError = createAction(
  '[Company Manager] Get My Managed Companies ERROR',
  props<{ errorMessage: string }>()
);

export const searchProcessesOfManagedEmployees = createAction(
  '[Company Manager] Search Processes Of Managed Employees',
  props<{ opts: SearchProcessesOfManagedEmployees }>()
);
export const searchProcessesOfManagedEmployeesSuccess = createAction(
  '[Company Manager] Search Processes Of Managed Employees SUCCESS',
  props<{ processes: PaginatedResponse<Partial<UserProcess>> }>()
);
export const searchProcessesOfManagedEmployeesError = createAction(
  '[Company Manager] Search Processes Of Managed Employees ERROR',
  props<{ errorMessage: string }>()
);

/**
 * =============================================================== Manager Candidate Verification
 */
export const searchCandidatesVerifications = createAction(
  '[Company Manager] Search Candidates Verifications',
  props<{ opts: SearchCandidateVerificationsOpts }>()
);
export const searchCandidatesVerificationsSuccess = createAction(
  '[Company Manager] Search Candidates Verifications SUCCESS',
  props<{ candidateVerification: PaginatedResponse<Partial<CandidateVerification>> }>()
);
export const searchCandidatesVerificationsError = createAction(
  '[Company Manager] Search Candidates Verifications ERROR',
  props<{ errorMessage: any }>()
);

export const getCandidateVerificationDetails = createAction(
  '[Company Manager] Get Candidate Verification Details',
  props<{ candidateVerificationId: string }>()
);
export const getCandidateVerificationDetailsSuccess = createAction(
  '[Company Manager] Get Candidate Verification Details SUCCESS',
  props<{ candidateVerification: CandidateVerification }>()
);
export const getCandidateVerificationDetailsError = createAction(
  '[Company Manager] Get Candidate Verification Details ERROR',
  props<{ errorMessage: any }>()
);

export const getCandidateVerificationHistory = createAction(
  '[Company Manager] Get Candidate Verification History',
  props<{ candidateVerificationId: string }>()
);
export const getCandidateVerificationHistorySuccess = createAction(
  '[Company Manager] Get Candidate Verification History SUCCESS',
  props<{ candidateVerificationHistory: CandidateVerificationHistory[] }>()
);
export const getCandidateVerificationHistoryError = createAction(
  '[Company Manager] Get Candidate Verification History ERROR',
  props<{ errorMessage: any }>()
);

export const addNewCandidateVerification = createAction(
  '[Company Manager] Add New Candidate Verification',
  props<{ opts: NewCandidateVerificationOpts }>()
);
export const addNewCandidateVerificationSuccess = createAction(
  '[Company Manager] Add New Candidate Verification SUCCESS',
  props<{ candidateVerification: Partial<CandidateVerification>; smsResult: SmsSendResult }>()
);
export const addNewCandidateVerificationError = createAction(
  '[Company Manager] Add New Candidate Verification ERROR',
  props<{ errorMessage: any }>()
);

export const updateCandidateVerificationBasicDetails = createAction(
  '[Company Manager] Update Candidate Verification Basic Details',
  props<{ candidateVerificationId: string; opts: UpdateCandidateVerificationDetailsOpts }>()
);
export const updateCandidateVerificationBasicDetailsSuccess = createAction(
  '[Company Manager] Update Candidate Verification Basic Details SUCCESS',
  props<{ candidateVerification: CandidateVerification; smsResult?: SmsSendResult | null }>()
);
export const updateCandidateVerificationBasicDetailsError = createAction(
  '[Company Manager] Update Candidate Verification Basic Details ERROR',
  props<{ errorMessage: any }>()
);

export const regenerateCandidateFormLinkAndPin = createAction(
  '[Company Manager] Regenerate Candidate Form Link And PIN',
  props<{ candidateVerificationId: string }>()
);
export const regenerateCandidateFormLinkAndPinSuccess = createAction(
  '[Company Manager] Regenerate Candidate Form Link And PIN SUCCESS',
  props<{ candidateVerification: CandidateVerification; smsResult: SmsSendResult }>()
);
export const regenerateCandidateFormLinkAndPinError = createAction(
  '[Company Manager] Regenerate Candidate Form Link And PIN ERROR',
  props<{ errorMessage: any }>()
);

export const setCandidateVerificationDecision = createAction(
  '[Company Manager] Set Candidate Verification Decision',
  props<{ candidateVerificationId: string; opts: UpdateCandidateVerificationDecisionOpts }>()
);
export const setCandidateVerificationDecisionSuccess = createAction(
  '[Company Manager] Set Candidate Verification Decision SUCCESS',
  props<{ candidateVerification: CandidateVerification }>()
);
export const setCandidateVerificationDecisionError = createAction(
  '[Company Manager] Set Candidate Verification Decision ERROR',
  props<{
    candidateVerificationId: string;
    opts: UpdateCandidateVerificationDecisionOpts;
    errorMessage: any;
  }>()
);

export const updateCandidateVerificationProcedureDecision = createAction(
  '[Company Manager] Update Candidate Verification Procedure Decision',
  props<{ candidateVerificationId: string; procedureId: string; decision: CandidateProcedureDecision }>()
);
export const updateCandidateVerificationProcedureDecisionSuccess = createAction(
  '[Company Manager] Update Candidate Verification Procedure Decision SUCCESS',
  props<{ candidateVerificationId: string; procedureId: string; decision: CandidateProcedureDecision }>()
);
export const updateCandidateVerificationProcedureDecisionError = createAction(
  '[Company Manager] Update Candidate Verification Procedure Decision ERROR',
  props<{
    candidateVerificationId: string;
    procedureId: string;
    decision: CandidateProcedureDecision;
    errorMessage: any;
  }>()
);

export const addCandidateOptionalServices = createAction(
  '[Company Manager] Add Candidate Optional Services',
  props<{ candidateVerificationId: string; services: ServiceTypeOptional[] }>()
);
export const addCandidateOptionalServicesSuccess = createAction(
  '[Company Manager] Add Candidate Optional Services SUCCESS',
  props<{
    candidateVerificationId: string;
    requestedServices: ServiceTypeOptional[];
    addedServices: CandidateProcedure[];
  }>()
);
export const addCandidateOptionalServicesError = createAction(
  '[Company Manager] Add Candidate Optional Services ERROR',
  props<{
    candidateVerificationId: string;
    requestedServices: ServiceTypeOptional[];
    errorMessage: any;
  }>()
);
